import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpdateStepDefinitionPayload } from '@klaro7/shared-types';

import {
  getQuestionnaireDefinition,
  updateStepDefinition,
} from '../services/questionnaire-definition.service';

export function useQuestionnaireDefinition() {
  return useQuery({
    queryKey: ['questionnaire-definition'],
    queryFn: () => getQuestionnaireDefinition(),
  });
}

export function useUpdateStepDefinition() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ step, payload }: { step: number; payload: UpdateStepDefinitionPayload }) =>
      updateStepDefinition(step, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['questionnaire-definition'] });
    },
  });
}
